// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p1Dp","toggleWrap":"styles_toggleWrap__1VCK5","content":"styles_content__1v7ha","selectAreaCode":"styles_selectAreaCode__1lzVw"};